export default (el) => ({
  id: String(el.id),
  title: el.title || '',
  subtitle: el.subtitle || '',
  description: el.description || '',
  author: el.author || '',
  age: el.age ? `${el.age}+` : '',
});
